import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';

export interface ISubDepartmentControlProps {
  name: string;
  id: string;
}

export const SubDepartmentControl: React.FC<ISubDepartmentControlProps> = ({
  name,
  id,
}) => {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      blockWidth
      label="Sub Department"
    />
  );
};
